var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 19.5L19.8 14.3V19.5H6.6V6.5H19.8V11.7L26.4 6.5M29.7 0H3.3C2.42479 0 1.58542 0.34241 0.966547 0.951903C0.347677 1.5614 0 2.38805 0 3.25V22.75C0 23.612 0.347677 24.4386 0.966547 25.0481C1.58542 25.6576 2.42479 26 3.3 26H29.7C30.5752 26 31.4146 25.6576 32.0335 25.0481C32.6523 24.4386 33 23.612 33 22.75V3.25C33 1.44625 31.515 0 29.7 0Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5226f41c2fa1afe073bf014385af32c1.svg";
export { ForwardRef as ReactComponent };